import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { GEO_CALCULATION_SERVICE_ADDRESS } from "../modals/constants";
import { GeoCalculationsJob } from "../models/GeoCalculations";

export function usePostGeoCalculationJob() {
  const queryClient = useQueryClient();
  return useMutation<string, AxiosError, GeoCalculationsJob>(
    async (data: GeoCalculationsJob) => {
      const response = await axios.post(
        `${GEO_CALCULATION_SERVICE_ADDRESS}/geo-calculation/jobs`,
        data
      );
      if (response.status !== 200) {
        throw new Error("Error creating access token");
      }

      return response.data;
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries("geoCalculations");
      }
    }
  );
}
